import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
import { SIGNATORY_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const SIGNATORY_READ = gql `
    ${SIGNATORY_FIELDS}
    query readSignatory($dossierId: Long) {
      read_signatory(dossierId: $dossierId) {
        ...SignatoryFields
      }
    }
  `;
export const useSignatoryReadLazyQuery = (options) => {
    return useLazyQuery(SIGNATORY_READ, Object.assign({ errorPolicy: 'all' }, options));
};
export const useSignatoryReadQuery = (options) => {
    return useQuery(SIGNATORY_READ, Object.assign({ errorPolicy: 'all' }, options));
};
export const useSignatoryReadQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: SIGNATORY_READ, variables }));
};
